module.exports = __webpack_public_path__ + "img/ivan-vazov-national-theater.38f899a1.jpg";